import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';
import {ChipsService} from '../../../../../../shared/components/clickatell-chip/chips.service';

export interface Tag {
  name: string;
}

@Component({
  selector: 'app-bot-tags',
  templateUrl: './bot-tags.component.html',
  styleUrls: ['./bot-tags.component.scss']
})
export class BotTagsComponent implements OnInit, OnDestroy {

  @Input() existingBotTagList;

  @Output() tagsList = new EventEmitter<Tag[]>();
  @Output() touched = new EventEmitter<boolean>();

  constructor(public chipsService: ChipsService) {
  }

  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  tags: Tag[] = [];
  isTouched = false;

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    if (value) {
      this.tags.push({name: value});
      this.tagsList.emit(this.tags);
      this.chipsService.addValidatorValues(value.toLowerCase()); // Checking if duplicates
    }

    event.chipInput!.clear();
  }

  remove(removeTag: Tag): void {
    const index = this.tags.indexOf(removeTag);

    if (index >= 0) {
      this.tags.splice(index, 1);
      this.tagsList.emit(this.tags);
      this.touched.emit(true);
      this.chipsService.removeValidatorValues(removeTag.name?.toLowerCase());

    }
  }

  onFocusEvent(e) {
    if (this.isTouched === false) {
      this.isTouched = true;
      this.touched.emit(this.isTouched);
    }
  }

  checkDuplication(value) {
    const duplicateList = this.tags.filter( tag => tag['name'] === value);
    if (duplicateList.length > 0) {

    }

  }

  ngOnInit(): void {
    this.chipsService.setDoValidation = true;

    // for an existingBot, load existing tags
    for ( const tag of this.existingBotTagList) {
      this.tags.push(tag);
    }
    this.chipsService.addChips(this.tags.map( item => item.name));

  }

  ngOnDestroy(): void {
    this.chipsService.resetChipsData();
  }

}
